import { api, unwrap } from '$lib/api/client';
import { unitSystem, type PlatformUnit } from '$lib/domain/units';
import { i18n } from '$lib/i18n/i18n.svelte';
import { toast } from './toast.svelte';

/**
 * The platform's measurement units, loaded once signed in (also in the setup flow) and again with every resync, so
 * a super-admin's change reaches open apps too. Until they arrive nothing is offered, and a stored unit still shows
 * as itself.
 */
class UnitsState {
	list = $state<PlatformUnit[]>([]);

	system = $derived(unitSystem(this.list));

	async refresh() {
		try {
			this.list = await unwrap(api.GET('/api/units'));
		} catch {
			// Keep the last known units; with none yet, say so, as the next resync tries again.
			if (this.list.length === 0) toast.show(i18n.t.errors.unitsUnavailable, 'warning');
		}
	}
}

export const units = new UnitsState();
